/**
 * 与 /transfer、/api/balancelist 配合：解析列表结构、匹配 platform_name / platname、读取余额字段
 */

export function rowsFromBalanceListResponse(res) {
  if (!res || res.code !== 200) {
    return [];
  }
  const d = res.data;
  if (Array.isArray(d)) {
    return d;
  }
  if (d && typeof d === 'object') {
    if (Array.isArray(d.list)) {
      return d.list;
    }
    if (Array.isArray(d.data)) {
      return d.data;
    }
    if (Array.isArray(d.items)) {
      return d.items;
    }
    if (Array.isArray(d.result)) {
      return d.result;
    }
  }
  return [];
}

export function pickPlatKey(row) {
  if (!row || typeof row !== 'object') {
    return '';
  }
  if (row.platname != null && String(row.platname) !== '') {
    return String(row.platname);
  }
  if (row.platform_name != null && String(row.platform_name) !== '') {
    return String(row.platform_name);
  }
  if (row.plat_name != null && String(row.plat_name) !== '') {
    return String(row.plat_name);
  }
  if (row.platformname != null && String(row.platformname) !== '') {
    return String(row.platformname);
  }
  return '';
}

export function pickVenueBalance(row) {
  if (row == null) {
    return null;
  }
  const keys = ['balance', 'user_balance', 'game_balance', 'venue_balance', 'money', 'blance'];
  for (let i = 0; i < keys.length; i++) {
    const v = row[keys[i]];
    if (v != null && v !== '') {
      return v;
    }
  }
  return null;
}

function norm(s) {
  return String(s || '')
    .trim()
    .toLowerCase();
}

function alnum(s) {
  return String(s).replace(/[^a-z0-9]/g, '');
}

/**
 * 与游戏入口的 platform_name / platname 对应（不区分大小写，必要时按字母数字比对）
 */
export function findVenueRowInList(list, platformName) {
  const want = norm(platformName);
  if (!want || !Array.isArray(list) || !list.length) {
    return null;
  }
  for (let i = 0; i < list.length; i++) {
    const r = list[i];
    if (norm(pickPlatKey(r)) === want) {
      return r;
    }
  }
  const w2 = alnum(want);
  if (w2) {
    for (let j = 0; j < list.length; j++) {
      const r = list[j];
      if (alnum(pickPlatKey(r)) === w2) {
        return r;
      }
    }
  }
  return null;
}

export function formatBalanceValue(v) {
  if (v == null || v === '') {
    return '0.00';
  }
  const n = parseFloat(String(v).replace(/,/g, ''));
  if (Number.isNaN(n)) {
    return '0.00';
  }
  return n.toFixed(2);
}



// WEBPACK FOOTER //
// ./src/utils/balancelistHelper.js